export const FONTS = [
  { label: 'Default Font', value: '' },
  { label: 'Arial', value: 'Arial' },
  { label: 'Calibri', value: 'Calibri' },
  { label: 'Comfortaa Bold', value: 'Comfortaa-Bold' },
  { label: 'Fontawesome', value: 'Fontawesome' },
]
